// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Hypervolar from './pages/Hypervolar';
import N2 from './pages/N2';
import N3 from './pages/N3';
import IVFSoftwarePage from './pages/Ivf';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/v1" element={<Hypervolar />} />
        <Route path="/" element={<N2 />} />
        <Route path="/v0"   element={<N3 />} />
         <Route path="/" element={<N2 />} />
          <Route path="/ivf-software" element={<IVFSoftwarePage />} />
      </Routes>
    </Router>
  );
}

export default App;